const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, any> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as any;
    
    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }
    
    // Merge all named exports into translation
    Object.keys(module).forEach((key) => {
      if (key !== 'default') {
        messages[lang].translation[key] = module[key];
      }
    });
  }
});

export default messages;
